import script from "./BodySubSecurity.vue?vue&type=script&setup=true&lang=js"
export * from "./BodySubSecurity.vue?vue&type=script&setup=true&lang=js"

const cssModules = {}
import style0 from "./BodySubSecurity.vue?vue&type=style&index=0&id=7a6fef6e&module=security&lang=css"
cssModules["security"] = style0

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__cssModules',cssModules]])

export default __exports__
import QImg from 'quasar/src/components/img/QImg.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import qInstall from "../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QImg,QBtn});
